import React from "react";

// 20-cell ASCII credibility bar.  Color changes by tier.
const CredibilityBar = ({ score = 0, max = 100, label = "CREDIBILITY", testId }) => {
  const cells = 20;
  const filled = Math.max(0, Math.min(cells, Math.round((score / max) * cells)));
  const empty = cells - filled;

  let tone = "";
  if (score < 33) tone = "danger";
  else if (score < 66) tone = "warn";

  return (
    <div data-testid={testId} className={`cred-bar ${tone}`}>
      <span className="muted">{label}</span>{" "}
      <span>
        [<span className="full">{"█".repeat(filled)}</span>
        <span className="empty">{"░".repeat(empty)}</span>]
      </span>{" "}
      <span className="muted">{Math.round(score)}/100</span>
    </div>
  );
};

export default CredibilityBar;
